define('OutSystems/ClientRuntime/CookiesManager',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.readCookie = exports.initialize = void 0;
    var nativeHttp;
    function initialize(nativeHttpPlugin) {
        nativeHttp = nativeHttpPlugin;
    }
    exports.initialize = initialize;
    function getCookies() {
        if (nativeHttp) {
            return nativeHttp.getCookies();
        }
        else {
            return document.cookie;
        }
    }
    function readCookie(cookieName) {
        var cookieKey = cookieName + "=";
        var cookies = getCookies().split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === " ") {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(cookieKey) === 0) {
                return decodeURIComponent(cookie.substring(cookieKey.length, cookie.length));
            }
        }
        return null;
    }
    exports.readCookie = readCookie;
});
//# sourceMappingURL=CookiesManager.js.map;
